export default __webpack_public_path__ + "static/media/sounds/clpl_model_sentence_start.mp3";